import { DigitalData } from "@/src/types/digitalData";

/**
 * Validates DigitalData structure before dispatching
 */
export const isValidDigitalData = (data: unknown): data is DigitalData => {
  if (!data || typeof data !== "object") {
    return false;
  }

  const ddl = data as Partial<DigitalData>;

  // Check required top-level fields
  if (
    typeof ddl.pageInstanceID !== "string" ||
    !ddl.version ||
    !ddl.page ||
    !Array.isArray(ddl.user) ||
    ddl.user.length === 0
  ) {
    return false;
  }

  // Check page structure
  if (
    typeof ddl.page.pageInfo?.pageID !== "string" ||
    !ddl.page.category?.pageType
  ) {
    return false;
  }

  // Every data layer MUST have either primaryCategory or tags
  const category = ddl.page.category;
  if (
    typeof category?.primaryCategory !== "string" &&
    (!Array.isArray(category?.tags) || category.tags.length === 0)
  ) {
    return false;
  }

  // Check user structure
  const user = ddl.user[0];
  if (typeof user?.segment?.loginstatus !== "string") {
    return false;
  }

  // Profile is only required when user is logged in
  if (user.segment.loginstatus === "loggedin") {
    if (!Array.isArray(user.profile) || user.profile.length === 0) {
      return false;
    }

    // Validate profileInfo structure for analytics requirements
    const profile = user.profile[0];
    if (!profile?.profileInfo) {
      return false;
    }

    // Authenticated users must have almaIDHash and accountType for Alma tunnus analytics
    const profileInfo = profile.profileInfo;
    if (
      typeof profileInfo?.almaIDHash !== "string" ||
      typeof profileInfo?.accountType !== "string"
    ) {
      return false;
    }
  }

  return true;
};
